<label *ngIf="!labelForm" for="cotista">Cotista:</label>
<label *ngIf="labelForm" class="form-label"  for="cotista">Cotista:</label>
<ng-select
  [(ngModel)]="cotista"
  id="cotista"
  [items]="cotistas"
  [bindLabel]="tipoOrdenacaoEPesquisa"
  [readonly]="readonly"
  [multiple]="false"
  [clearable]="true"
  [clearOnBackspace]="true"
  [searchable]="true"
  placeholder="Todos"
  class="auto-grow"
  (change)="selecionar($event)">
  <ng-template ng-label-tmp let-item="item">
    {{ getLabel(item) }}
  </ng-template>
  <ng-template ng-option-tmp let-item="item" container="body">
    {{ getLabel(item) }} {{ getLabelWithCnpj(item) }}
  </ng-template>
</ng-select>
